'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./star-rating.scss');

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SIZE = {
  small: '16',
  medium: '26',
  large: '36'
};

var StarRating = function (_React$Component) {
  _inherits(StarRating, _React$Component);

  function StarRating(props) {
    _classCallCheck(this, StarRating);

    var _this = _possibleConstructorReturn(this, (StarRating.__proto__ || Object.getPrototypeOf(StarRating)).call(this, props));

    _this.handleOnMouseOver = _this.handleOnMouseOver.bind(_this);
    _this.handleOnMouseOut = _this.handleOnMouseOut.bind(_this);
    _this.renderStarts = _this.renderStarts.bind(_this);
    _this.classes = _this.classes.bind(_this);

    _this.state = {
      rating: 0
    };
    return _this;
  }

  _createClass(StarRating, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // eslint-disable-next-line
      this.setState({ rating: this.props.rating });
    }
  }, {
    key: 'classes',
    value: function classes() {
      return (0, _classnames2.default)('star-rating', 'star-rating--size-' + this.props.size, this.props.className);
    }
  }, {
    key: 'handleOnMouseOver',
    value: function handleOnMouseOver(rating) {
      this.setState({ rating: rating });
      this.props.onMouseOver(rating);
    }
  }, {
    key: 'handleOnMouseOut',
    value: function handleOnMouseOut() {
      this.setState({ rating: this.props.rating });
      this.props.onMouseOut();
    }
  }, {
    key: 'renderStarts',
    value: function renderStarts() {
      var _this2 = this;

      return new Array(this.props.stars).fill(null).map(function (star, index) {
        var rating = index + 1;
        return _react2.default.createElement(_icon2.default, {
          key: 'starRating-' + rating,
          name: _this2.state.rating >= rating ? 'star-filled' : 'star',
          size: SIZE[_this2.props.size],
          onClick: _this2.props.onClick ? function () {
            return _this2.props.onClick(rating);
          } : undefined,
          onMouseOver: _this2.props.onClick ? function () {
            return _this2.handleOnMouseOver(rating);
          } : undefined,
          onMouseOut: _this2.props.onClick ? function () {
            return _this2.handleOnMouseOut();
          } : undefined,
          color: 'secondary'
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.classes() },
        this.renderStarts()
      );
    }
  }]);

  return StarRating;
}(_react2.default.Component);

StarRating.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  onMouseOver: _propTypes2.default.func,
  onMouseOut: _propTypes2.default.func,
  rating: _propTypes2.default.number,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  stars: _propTypes2.default.number
};

StarRating.defaultProps = {
  rating: 0,
  size: 'medium',
  stars: 5
};

exports.default = StarRating;